import styled from 'styled-components';

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-size: 0.95rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #333;
`;

export const TextInput = styled.input`
  padding: 0.6rem 0.75rem;
  font-size: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  transition: border-color 0.2s ease;
  &:focus {
    border-color: #0070f3;
    outline: none;
  }
`;